export default {
	navbar: {
		home: '开发者首页',
		doLogin: '立即登录',
		document: '文档中心',
		regist: '免费注册',
		login: {
			control: '控制中心',
			logOut: '退出登录'
		},
		notice: {
			logOut: {
				title: '系统提示',
				message: '确认退出登录？',
				confirm: '立即退出',
				cancel: '暂不退出',
			}
		}
	},
	login: {
		title: '密码登录',
		userNamePersonal: '登录名/手机号',
		userNameEnterprise: '登录名/企业名称',
		password: '登录密码',
		captcha: '图形验证码',
		captchaTip: '看不清，点击换一张',
		remember: '记住账号',
		forgot: '忘记密码？',
		btn: '登录',
		control: '控制中心',
		switch: '切换账号',
		loginRule: {
			userName: '请输入登录名',
			password: '请输入登录密码',
			code: '请输入图形验证码',
		}
	},
	home: {
		introduce: '什么是JOSH Cloud？',
		introDoc: 'JOSH Cloud是为广大开发者搭建的智能物联网设备管理系统，用户可管理设备及应用程序，自行开发应用程序上传至平台，并将应用程序远程推送到设备上运行。',
		regist: '加入JOSH Cloud',
		registDoc: '用户可通过JOSH Cloud账号加入并使用平台，首次登录后建议用户首先完善个人信息，以便使用平台中各项功能。（注：忘记密码操作需要账号邮箱，请优先激活！）',
		registContent: {
			step1: '注册开发者账号',
			step2: '登录JOSH Cloud',
			step3: '激活登录邮箱',
			step4: '绑定/激活安全邮箱'
		},
		develop: 'JOSH Cloud使用指南',
		devDoc: 'JOSH Cloud是为广大开发者搭建的智能物联网设备管理系统，本教程旨对平台使用流程、操作方法进行全面描述与讲解，以便开发者更快的熟悉平台功能。',
		sdk: 'SDK使用教程',
		sdkDoc: '本教程通过IDE使用说明、开发板安装调试教学及开发板介绍等几部分教程，指导开发者快速上手开发调试开发板应用程序，并提供大量API使用示例供开发者参考。',
		vm: 'JoshVM开放文档',
		vmDoc: '文档施工中……',
		community: 'Josh开发者社区',
		communityLink: 'JOSH开发者社区是面向开发者的开放型技术平台。包含问答、技术分享、资源下载等模块，以分享专业、优质、高效的技术为主要目标，帮助技术人快速成长与发展。' 
	},
	navMenu: {
		overview: '监测/概览',
		deviceManage: '设备管理',
		device: '设备',
		group: '分组',
		task: '任务',
		certificate: '证书管理',
		appManage: '应用管理',
		privateApp: '个人应用',
		publicApp: '应用商店',
		application:'应用类型',
		visualManage: '可视化管理',
		visualType: '可视化类型',
		visualPage: '可视化页面',
		blockManage: '区块链管理',
		blockPage: '区块链',
		user: '个人账户',
		helpDoc: '帮助文档',
		server: '平台服务',
		serverAudio: '语音服务',
	},
	server: {
		noData: '暂无数据',
		audio: {
			key: 'ApiKey',
			secret: 'ApiSecret',
			table: {
				orderIndex: '序号',
				name: '服务项',
				limit: '使用限制'
			}
		}
	},
	userinfo: {
		title: '个人账户',
		buy: {
			title: '购买安装应用次数',
			confirm: '确定',
			num: '数量',
			money: '金额',
			rule: {
				num: '请输入购买数量'
			}
		},
		buyVisual: {
			title: '购买数据可视化次数',
			confirm: '确定',
			num: '数量',
			money: '金额',
			type: '类型',
			select: '请选择',
			rule: {
				num: '请输入购买数量',
				type: '请选择类型',
			}
		},
		buyBlock: {
			title: '购买区块链次数',
			confirm: '确定',
			num: '数量',
			money: '金额',
			type: '类型',
			select: '请选择',
			rule: {
				num: '请输入购买数量',
				type: '请选择类型',
			}
		},
		buyLog: {
			title: '购买日志服务',
			confirm: '确定',
			months: '月数',
			money: '金额',
			select: '请选择',
			qrTip: '请使用微信支付',
			order: {
				title: '购买记录',
				months: '月数',
				amount: '支付金额',
				payState: '支付状态',
				orderNo: '订单编号',
				creTime: '订单创建时间',
				completionTime: '订单完成时间',
				orderDesc: '订单状态',
				productDesc: '订单详情',
				printInvoice: '申请开票状态',
				printInvoiceTime: '开票时间',
				noData: '暂无数据',
				select: '请选择',
				query: '搜索',
				empty: '清空条件',
			},
			invoice: {
				title: '发票记录',
				invoiceInfo: '发票信息',
				toInvoice: '去开票',
				invoiceHeader: '发票抬头',
				invoiceType: '发票类型',
				unifiedSocialCreditCode: '统一社会信用代码',
				nameOfDepositBank: '开户银行名称',
				basicAccountNumber: '基本开户账号',
				addrOfRegisteredPlace: '注册场所地址',
				registeredFixedTelephone: '注册固定电话',
				mailingAddress: '寄送地址',
				addressee: '收件人姓名',
				telephone: '收件人电话',
				mailbox: '收件人邮箱',
				invoiceSelectTip: '请选择要开票的订单',
				preview: '开票订单预览',
				rule: {
					invoiceHeader: '请输入发票抬头',
					invoiceType: '请选择发票类型',
					unifiedSocialCreditCode: '请输入统一社会信用代码',
					nameOfDepositBank: '请输入开户银行名称',
					basicAccountNumber: '请输入基本开户账号',
					addrOfRegisteredPlace: '请输入注册场所地址',
					registeredFixedTelephone: '请输入注册固定电话',
					mailingAddress: '请输入寄送地址',
					addressee: '请输入收件人姓名',
					telephone: '请输入收件人电话',
					mailbox: '请输入收件人邮箱',
				}
			},
			rule: {
				months: '请输入购买月数',
			}
		},
		personal: {
			nickName: '登录名',
			phoneNum: '手机号',
			updatePassword: '修改密码',
			addDeviceNum: '可添加设备数量',
			installAppNum: '可安装应用次数',
			toBuy: '去购买',
			blockStatus: '区块链功能',
			toApply: '去申请',
			applyTip: '申请已提交，请等待',
			download: '下载',
			logStatus: '日志功能'
		},
		enterprise: {
			nickName: '登录名',
			enterpriseName: '企业名称',
			businessLicense: '营业执照',
			uuid:'账号ID',
			enterpriseMailbox: '企业邮箱',
			contactTelephone: '联系人电话',
			updatePassword: '修改密码',
			installAppNum: '可安装应用次数',
			auditStatus: '审核状态',
			auditDesc: '审核失败原因',
			joshid: 'JOSHID',
			joshkey: 'JOSHKEY',
			create: '生成',
			update: '更新',
			toBuy: '去购买',
			visualStatus: '数据可视化功能',
			toApply: '去申请',
			applyTip: '申请已提交，请等待',
		},
    updatePassword: {
    	resetPassword: '重置密码',
    	oldPassword: '旧密码',
    	newPassword: '新密码',
    	newPasswordTip: '密码由6-20位数字与字母组成',
    	confirmPassword: '确认密码',
    	confirm: '确认',
    	editRule: {
    		oldPassword: '请输入旧密码',
    		newPassword: '请输入新密码',
    		newPasswordError: '密码需由6-20位数字与字母组成',
    		confirm: '请再次确认密码',
    		confirmError: '两次密码不同，请重新确认'
    	}
    },
	},
	control: {
		overview:{
			title: '监控/概览',
			deviceNum: '设备数量',
			groupNum: '分组数量',
			appNum: '应用数量',
			taskNum: '任务数量',
			activeNum: '激活数量',
			onlineNum: '在线数量',
			isDoing: '进行中',
			goBuy: '去购买'
		},
		device: {
			list: {
				title: '设备列表',
				deviceName: '设备名称',
				IMEI: 'IMEI',
				deviceType: '设备类型',
				grouping: '所属分组',
				appInfo: '应用信息',
				activeState: '激活状态',
				connectState: '连接状态',
				bindState: '绑定状态',
				delFlag: '删除状态',
				lastHeartTime: '最后在线时间',
				select: '请选择',
				noData: '暂无数据',
				confirm: '确定',
				tips: '提示',
				operateSuccess: '操作成功',
				cancel: "已取消",
				operate: '操作',
				add: '添加',
				batchOperate: '批量操作',
				installCrt: '安装证书',
				lookLog: '查看日志',
				installCrtTip: '请选择要安装证书的设备',
				operationTip: '请选择要批量操作的设备',
				batchOperateTip: '请选择要批量操作的设备',
				query: '搜索',
				empty: '清空条件',
				look: '查看',
				delete: '删除',
				edit: '编辑',
				applyDelete: '申请删除',
				remove: '移除',
			},
			create: {
				createTitle: '添加设备',
				editTitle: '编辑设备',
				deviceName: '设备名称',
				confirm: '确定',
				rule: {
					deviceName: '请输入设备名称',
				}
			},
			detail: {
				title: '设备详情',
				deviceName: '设备名称',
				deviceType: '设备类型',
				creTime: '添加时间',
				getCode: '获取激活码',
				createCrt: '生成证书',
				code: '激活码',
				paperNotic: '生成的证书将覆盖原有证书，且平台不做保存，请妥善管理',
				refresh: '刷新',
				restartDevice: '重启设备',
				checkConnect: '检查连接状态',
				expireTime: '过期时间',
				copy: '复制',
				copySuccess: '复制成功',
				lastHeartTime: '最后连接时间',
				group: '所属分组',
				activeState: '激活状态',
				connectState: '连接状态',
				bindState: '绑定状态',
				connectCheck: '连接检查状态',
				appInfo: '应用信息',
				taskRecord: '任务记录',
				logList: '日志记录',
				operationTip: '操作成功',
				notActiveTip: '该设备未激活，不能进行该操作',
				notConnectTip: '该设备已离线，不能进行该操作',
				notBindTip: '该设备未绑定，不能进行该操作',
				app: {
					getApps: '更新应用记录',
					refresh: '刷新',
					appName: '应用名称',
					appIdentification: '应用标识',
					appVersion: '版本号',
					appV: '版本号(JAR)',
					appMainClass: '主类名',
					appDesc: '备注',
					appState: '应用状态',
					isNative: '本地应用',
					appSet: '应用配置',
					creTime: '上传时间',
					installTime: '安装时间',
					uninstallTime: '卸载时间',
					isPublic: '可见性',
					deviceType: '适用设备',
					operate: '操作',
					detail: '查看',
					install: '安装',
					run: '运行',
					stop: '停止',
					uninstall: '卸载',
					enable: '启用',
					visual: '可视化',
					history: '历史',
					log: '日志',
					logTip: '日志服务需要申请并购买，请到个人账户操作',
					logs: {
						query: '查询',
						stop: '停止',
						empty: '清空',
						history: '历史日志',
						export: '导出日志',
						queryTip: '开始查询日志，请在当前页面等待',
						stopTip: '已经停止日志',
						historyTitle: '选择日志类型',
						historyErrorTip: '请先获取历史日志再导出日志',
						noHistoryTip: '设备还未上传日志文件，请稍后再做此操作',
						isNew: '日志类型',
						confirm: '确定',
						rule: {
							isNew: '请选择日志状态',
						}
					},
					appSetting: {
						title: '安装应用配置',
						confirm: '确定',
					}
				},
				task: {
					addTask: '添加任务',
					taskNumber: '任务编号',
					taskType: '任务类型',
					select: '请选择',
					startTime: '开始日期',
					endTime: '结束日期',
					to: '至',
					noData: '暂无数据',
					createTime: '发起时间',
					remake: '备注',
					otherSet: '其它设置',
					appInfo: '应用信息',
					launchTime: '发起时间',
					endTime: '完成时间',
					deviceNum: '设备数量',
					finishNum: '完成数量',
					taskState: '任务状态',
					operate: '操作',
					add: '添加',
					query: '搜索',
					empty: '清空条件',
					look: '查看',
					delete: '删除',
					serialNumber: '序号',
				},
				log: {
					logTitle: '日志列表',
					reportLogtitle: '上报日志',
					operateLogtitle: '操作日志',
					reportName: '上报类型',
					code: '上报码',
					reportContent: '上报内容',
					reportTime: '上报时间',
					taskNumber: '任务编号',
					taskItemNumber: '任务项编号',
					createTime: '上报时间',
					startTime: '开始时间',
					endTime: '结束时间',
					query: '搜索',
					empty: '清空条件',
					serialNumber: '序号',
					select: '请选择',
					title: '操作类型',
					appName: '应用名称',
					appIdentification: '应用标识',
					appV: '应用版本',
					appSupplier: '制造者',
					operTime: '操作时间',
					deviceCount: '设备数量',
					imei: 'IMEI'
				}
			},
			operation: {
				title: '批量操作',
				operateType: '操作类型',
				configure: '配置',
				remark: '任务备注',
				selectDevice: '选择设备',
				selectGroup: '选择分组',
				abstract: '摘要',
				appSelect: '应用选择',
				number: '编号',
				name: '名称',
				type: '类型',
				operationTip: '操作成功',
				needAppTip: '请选择要操作的应用',
				rule: {
					operateType: '请选择操作类型',
				}
			}
		},
		group: {
			list: {
				title: '分组列表',
				groupNumber: '分组编号',
				groupName: '分组名称',
				creTime: '创建时间',
				addTime: '添加时间',
				deviceNum: '设备数量',
				startTime: '开始日期',
				endTime: '结束日期',
				to: '至',
				noData: '暂无数据',
				operate: '操作',
				groupDesc: '备注',
				add: '添加',
				query: '搜索',
				empty: '清空条件',
				look: '查看',
				delete: '删除',
			},
			create: {
				editTitle: '修改分组',
				title: '添加分组',
				groupName: '分组名称',
				groupDesc: '备注',
				confirm: '确定',
				rule: {
					groupName: '请输入分组名称'
				}
			},
			detail: {
				title: '分组详情',
				groupNumber: '分组编号',
				groupName: '分组名称',
				creTime: '添加时间',
				deviceNum: '设备数量',
				activeNum: '激活数量',
				onlineNum: '在线数量',
				groupDesc: '备注',
				deviceList: '设备列表',
				taskRecord: '任务记录'
			}
		},
		task: {
			list: {
				title: '任务列表',
				taskNumber: '任务编号',
				taskType: '任务类型',
				select: '请选择',
				startTime: '开始日期',
				endTime: '结束日期',
				to: '至',
				noData: '暂无数据',
				createTime: '创建时间',
				remake: '备注',
				otherSet: '其它设置',
				appInfo: '应用信息',
				launchTime: '发起时间',
				endTime: '完成时间',
				deviceNum: '设备数量',
				finishNum: '完成数量',
				operate: '操作',
				add: '添加',
				query: '搜索',
				empty: '清空条件',
				look: '查看',
				delete: '删除',
			},
			create: {
				title: '添加任务',
				taskNumber: '任务编号',
				taskType: '任务类型',
				configure: '配置',
				remark: '任务备注',
				selectDevice: '选择设备',
				selectGroup: '选择分组',
				abstract: '摘要',
				appSelect: '应用选择',
				number: '编号',
				name: '名称',
				type: '类型',
				rule: {
					taskNumber: '请输入任务编号',
					type: '请选择任务类型'
				}
			},
			detail: {
				title: '任务详情',
				taskNumber: '任务编号',
				taskType: '任务类型',
				otherSet: '其它设置',
				deviceNum: '设备数量',
				appName: '应用名称',
				finishNum: '完成数量',
				version: '版本号',
				createTime: '创建时间',
				remake: '备注',
				deviceList: '设备列表',
				finalReport: '最后上报内容',
				taskState: '任务状态',
				updateTime: '更新时间'
			}

		},
		cert: {
			list: {
				title: '证书列表',
				certNumber: '证书编号',
				certName: '证书名称',
				relation: '关联设备数量',
				select: '请选择',
				state: '状态',
				enable: '启用',
				disable: '禁用',
				createTime: '创建时间',
				noData: '暂无数据',
				operate: '操作',
				add: '添加',
				query: '搜索',
				empty: '清空条件',
				look: '查看',
				delete: '删除',

			},
			create: {
				title: '添加证书',
				certName: '证书名称',
				cert: '证书',
				publicKey: '公有私钥',
				privateKey: '私有密钥',
				download: '下载',
				confirm: '确认'
			},
			detail: {
				title: '证书详情',
				certNumber: '证书编号',
				certName: '证书名称',
				state: '状态',
				download: '下载',
				deviceNum: '设备数量',
				publisher: '发布者',
				theme: '主题',
				createDate: '创建日期',
				effectiveDate: '生效日期',
				expirationDate: '到期日期'
			}
		},
		app: {
			list: {
				title: '应用列表',
				appName: '应用名称',
				appVersion: '版本号',
				appV: '版本号(JAR)',
				appIdentification: '应用标识',
				appSupplier: '制造者',
				appMainClass: '主类名',
				deviceType: '适用设备',
				isPublic: '可见性',
				auditState: '审核状态',
				appDesc: '备注',
				creTime: '上传时间',
				creUser: '上传用户',
				delFlag: '删除状态',
				operate: '操作',
				noData: '暂无数据',
				add: '添加',
				query: '搜索',
				empty: '清空条件',
				look: '查看',
				private: '私有',
				public: '公开',
				delete: '删除',
				select: '请选择',
				bind: '绑定',
				preview: '预览',
			},
			create: {
				editTitle: '修改应用',
				title: '添加应用',
				appName: '应用名称',
				appVersion: '版本号',
				mainClass: '主类名',
				file: '源文件',
				selectFile: '选择文件',
				deviceType: '适用设备',
				isPublic: '可见性',
				appDesc: '备注',
				confirm: '确定',
				cDelete: '确定移除 ',
				uploadTip: '上传文件只能是.jar格式!',
				rule:{
					appName: '请输入应用名称',
					appVersion: '请输入版本号',
					mainClass: '请输入主类名',
					appUrl: '请上传文件',
					remark: '请输入备注',
					deviceType: '请选择适用设备',
					isPublic: '请选择可见性',
				}
			},
			detail: {
				title: '应用详情',
				appName: '应用名称',
				appVersion: '版本号',
				appIdentification: '应用标识',
				appSupplier: '制造者',
				appMainClass: '主类名',
				deviceType: '适用设备',
				certImei:'IMEI码',
				isPublic: '可见性',
				auditState: '审核状态',
				appDesc: '备注',
				creTime: '上传时间',
				creUser: '上传用户',
				file: '源文件',
				download: '下载',
				delete: '删除'
			},
			bind: {
				title: '绑定可视化页面',
				webId: '页面名称',
				rule:{
					webId: '请选择绑定页面',
				}
			}
		},
		visual: {
			list: {
				tip: '可视化功能需要申请，请到个人账户申请！',
				add: '添加',
				noData: '暂无数据',
				webName: '页面名称',
				deviceType: '类型',
				webDesc: '页面描述',
				creDate: '创建时间',
				query: '搜索',
				empty: '清空条件',
				select: '请选择',
				preview: '预览',
				deviceTypeName: '类型名称',
				download: '下载',
				errorTip: '页面解析异常',
				delFlg: '删除状态',
				temporarySave: '发布状态',
				delete: '删除',
				update: '修改',
				release: '发布',
			},
			create: {
				editTitle: '添加类型',
				deviceType: '类型名称',
				confirm: '确定',
				rule:{
					deviceType: '请输入类型名称',
				}
			}
		},
		block: {
			list: {
				tip: '区块链功能需要申请，请到个人账户申请！',
				dataCode: '数据标识',
				blockHash: '块哈希',
				blockHeight: '块高',
				blockGenerateDate: '块生成时间',
				noData: '暂无数据',
				query: '搜索',
				empty: '清空条件',
				dataDetails: '数据',
				imei: 'IMEI',
				check: '校验',
				checkSendTip: '校验下发成功，请稍等，请不要刷新页面',
				lookLog: '查看日志',
				appIdentification: '应用标识',
				appVersion: '应用版本'
			},
			detail: {
				title: '区块信息',
				ledgerHash: '账本哈希',
				height: '区块高度',
				timestamp: '区块生成时间',
				hash: '区块哈希',
				previousHash: '上一区块哈希',
				transactionSetHash: '交易数据集根哈希',
				contractAccountSetHash: '合约集根哈希',
				dataAccountSetHash: '数据账户集哈希',
				systemEventSetHash: '系统时间集根哈希',
				userAccountSetHash: '用户集根哈希',
				dataDetails: '数据写入：值',
			},
			log: {
				reportLogTitle: '上报日志',
				sendLogTitle: '下发日志',
				noData: '暂无数据',
				clientid: '操作ID',
				dataCode: '数据标识',
				imei: 'IMEI',
				issueTime: '下发时间',
				issueType: '下发类型',
				message: '下发消息',
				nickName: '用户名',
				query: '搜索',
				empty: '清空条件',
				reportType: '上报类型',
				reportTime: '上报时间',
				select: '请选择'
			}
		},
	},
	regist: {
		login: '去登录',
		title: '注册账号',
		personal: '个人用户',
		enterprise: '企业用户',
		admin: '管理员',
		nickName: '设置登录名',
		nickNameTip: '5-25个字符，不区分大小写，登录名一旦设置成功无法修改',
		phoneNum: '请输入手机号',
		phoneNumTip: '请输入未绑定过的手机号',
		captcha: '图形验证码',
		captchaTip: '看不清，点击换一张',
		verificationCode: '手机验证码',
		verificationCodeBtn: '获取手机验证码',
		enterpriseName: '请输入企业名称',
		businessLicense: '请输入营业执照',
		enterpriseMailbox: '请输入企业邮箱',
		contactTelephone: '请输入联系人电话',
		password: '设置您的登录密码',
		passwordTip: '登录密码由6-20位数字与字母组成',
		confirm: '请再次输入登录密码',
		btn: '立即注册',
		registRule: {
			nickNameEmpty: '请输入登录名',
			nickNameError: '登录名长度需在 5 到 25 个字符',
			phoneNumEmpty: '请输入手机号',
			phoneNumEmptyError: '手机号格式异常，请检查',
			captchaEmpty: '请输入图形验证码',
			verificationCodeEmpty: '请输入手机验证码',
			enterpriseNameEmpty: '请输入企业名称',
			businessLicenseEmpty: '请输入营业执照',
			emailEmpty: '请输入企业邮箱',
			emailError: '邮箱格式异常，请检查',
			contactTelephoneEmpty: '请输入联系人电话',
			passwordEmpty: '请设置您的登录密码',
			passwordError: '登录密码由6-20位数字与字母组成',
			confirmEmpty: '请再次输入登录密码',
			confirmError: '两次密码不同，请重新确认',
		}
	},
	forgot: {
		phoneNum: '请输入手机号',
		phoneNumTip: '请输入注册时绑定的手机号',
		captcha: '图形验证码',
		captchaTip: '看不清，点击换一张',
		verificationCode: '手机验证码',
		verificationCodeBtn: '获取手机验证码',
		password: '设置您的新登录密码',
		passwordTip: '登录密码由6-20位数字与字母组成',
		confirm: '请再次输入登录密码',
		success: '密码重置成功',
		btn: '立即修改',
		updatePasswordTip: '修改密码成功',
		forgotRule: {
			phoneNumEmpty: '请输入手机号',
			phoneNumEmptyError: '手机号格式异常，请检查',
			captchaEmpty: '请输入图形验证码',
			verificationCodeEmpty: '请输入手机验证码',
			passwordEmpty: '请设置您的新登录密码',
			passwordError: '登录密码由6-20位数字与字母组成',
			confirmEmpty: '请再次输入登录密码',
			confirmError: '两次密码不同，请重新确认',
		}
	},
	forgotStep1: {
		username: '邮箱/用户名',
		captcha: '图片验证码',
		captchaTip: '看不清，点击换一张',
		btn: '获取安全验证码',
		rule: {
			account: '请输入用户名或邮箱',
			captcha: '请输入图片验证码'
		}
	},
	forgotStep2: {
		code: '安全验证码',
		codeTip: '安全校验码已发送至账号安全邮箱，请前往查看',
		btn: '下一步',
		rule: {
			code: '请输入安全验证码'
		}
	},
	forgotStep3: {
		password: '新密码',
		passwordTip: '登录密码由6-20位数字与字母组成',
		confirm: '请再次输入新密码',
		btn: '完成',
		rule: {
			passwordEmpty: '请设置您的新密码',
			passwordError: '密码由6-20位数字与字母组成',
			confirmEmpty: '请再次输入新密码',
			confirmError: '两次密码不同，请重新确认',
		}
	},
	confirm: {
		confirm: '确认',
		cancel: '取消',
		deleteImmediately: '立即删除',
		applyImmediately: '立即申请',
		removeImmediately: '立即移除',
    noDeletion: '暂不删除',
    notRemoved: '暂不移除',
    notApply: '暂不申请',
    tips: '提示',
    process: '处理中...',
    deleteApp: '确定删除该应用吗？',
    deleteGroup: '确定删除该分组吗？',
    deleteCert: '确定删除该证书？',
    deleteDevice: '确定删除该设备？',
    applyDeleteDevice: '确定申请删除该设备？',
    removeDevice: '确定移除该设备？',
    deleteTask: '确定删除该任务？',
    addSuccess: '添加成功',
    editSuccess: '修改成功',
    operateSuccess: '操作成功，',
    deviceDelete: '设备已删除',
    deviceApplyDelete: '设备已申请删除',
    deviceRemove: '设备已移除',
    groupDelete: '分组已删除',
    taskDelete: '任务已删除',
    appDelete: '应用已删除',
		appPrivate: '应用已私有',
    certDelete: '证书已删除',
    activeSuccess: '激活成功',
    bindPhone: '当前账户未绑定手机号，请移步至“个人账户”绑定手机号',
    toBind: '去绑定',
    bindSuccess: '绑定成功',
    createCrt: '生成的证书将覆盖原有证书，原有证书将失效，是否生成证书？',
		publicApp: '确定公开该应用吗？',
		publicImmediately: '立即公开',
		noPublic: '暂不公开',
		publicTip: '公开应用需要审核，请稍后',
		publicErrorTip: '区块链应用不允许公开',
		restartDevice: '确定重启设备吗？',
		restartImmediately: '立即重启',
		noRestart: '暂不重启',
		checkConnect: '确定检查连接状态吗？',
		checkImmediately: '立即检查',
		noCheck: '暂不检查',
		stopApp: '确定停止该应用吗？',
		stopImmediately: '立即停止',
		noStop: '暂不停止',
		runApp: '确定运行该应用吗？',
		runImmediately: '立即运行',
		noRun: '暂不运行',
		uninstallApp: '确定卸载该应用吗？',
		uninstallImmediately: '立即卸载',
		noUninstall: '暂不卸载',
		installCrt: '确定为选中的设备安装证书吗？',
		installCrtImmediately: '立即安装',
		noInstallCrt: '暂不安装',
		refreshApps: '确定更新应用记录吗？',
		refreshAppsImmediately: '立即更新',
		noRefreshApps: '暂不更新',
		buySuccess: '购买成功',
		downloadFile: '确定下载页面配置文件吗？',
		downloadImmediately: '立即下载',
		noDownload: '暂不下载',
		enableVisual: '确定启用数据可视化吗？',
		enableImmediately: '立即启用',
		noEnable: '暂不启用',
		downloadBlockFile: '确定下载区块链配置文件吗？',
		exportLog: '确定导出该应用日志吗？',
		exportImmediately: '立即导出',
		noExport: '暂不导出',
		applySuccess: '申请成功',
		deleteVisual: '确定删除该页面？',
		visualDelete: '页面已删除',
		releaseVisual: '确定发布该页面？',
		visualRelease: '页面已发布',
		releaseImmediately: '立即发布',
		noRelease: '暂不发布',
	},
	tips: {
		bindPhone: {
			addDevice: '注：当前账户无法添加设备，请先前往',
			useAudio: '注：当前账户无法使用语音服务，请先前往',
			page: '个人账户',
			action: '绑定手机号'
		}
	},
	fixedBar: {
		feedback: '意见反馈',
		backTop: '返回顶部',
	},
	stApply: {
		title: 'ST板卡申请计划书',
		item: {
			pjname: '项目名称',
			name: '姓名',
			telephone: '联系电话',
			college: '院校/院系',
			email: '邮箱',
			address: '快递地址',
			post: '邮编',
			introduce: '项目引言',
			background: '项目背景',
			summary: '需求概述',
			field: '应用领域',
			device: '板卡选择',
			time: '开发周期',
			timeBegin: '开始日期',
			timeSplit: '至',
			timeEnd: '结束日期',
			reason: '申请出发点',
			btn: '确认提交',
		},
		rules: {
			input: '请填写',
			select: '请选择',
			emailError: '邮箱格式异常，请检查',
			telephoneError: '手机号格式异常，请检查',
		},
		notice: {
			title: '您尚未登录',
			content: '申请ST板卡前请先登录JOSH Cloud',
			btn: '去登录',
		}
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh.js